export default {"src":"/_next/static/media/early-payment-banner.21182d8f.svg","height":426,"width":448};